import { useCampaignDetail } from "./context";

export function TeamTab() {
  const { campaign } = useCampaignDetail();
  const others = campaign.teamMembers?.filter((m) => m.id !== campaign.createdBy.id) ?? [];

  return (
    <div className="max-w-2xl space-y-4">
      <div className="rounded-lg bg-card p-4 shadow-sm ring-1 ring-ring">
        <h3 className="text-sm font-medium text-text-secondary">Lead</h3>
        <div className="mt-2 flex items-center gap-2">
          <span className="text-sm text-text-primary">{campaign.createdBy.name}</span>
          <span className="rounded bg-accent-light px-1.5 py-0.5 text-xs font-medium text-amber-800 dark:text-amber-400">
            Lead
          </span>
        </div>
      </div>

      <div className="rounded-lg bg-card p-4 shadow-sm ring-1 ring-ring">
        <h3 className="text-sm font-medium text-text-secondary">Team members</h3>
        {others.length === 0 ? (
          <p className="mt-2 text-sm text-text-muted">No additional team members yet.</p>
        ) : (
          <ul className="mt-2 space-y-1">
            {others.map((member) => (
              <li key={member.id} className="text-sm text-text-primary">
                {member.name}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
